// Port of api/fuel/app/classes/filter/package/games/game.php
import ContextData from 'offline/filter/package/games/game/data/context'
import CommentsData from 'offline/filter/package/games/game/data/comments'
import ExpansionsData from 'offline/filter/package/games/game/data/expansions'
import ListingData from 'offline/filter/package/games/game/data/listing'
import NestedData from 'offline/filter/package/games/game/data/nested'
import PlaysData from 'offline/filter/package/games/game/data/plays'
import RankData from 'offline/filter/package/games/game/data/rank'
import RatingsData from 'offline/filter/package/games/game/data/ratings'
import RenamesData from 'offline/filter/package/games/game/data/renames'
import TagsData from 'offline/filter/package/games/game/data/tags'
import VersionsData from 'offline/filter/package/games/game/data/versions'

import ContextPlaysPrepare from 'offline/filter/package/games/game/prepare/context/plays'
import ExpansionsPrepare from 'offline/filter/package/games/game/prepare/expansions'
import OwnersPrepare from 'offline/filter/package/games/game/prepare/owners'
import PlaysPrepare from 'offline/filter/package/games/game/prepare/plays'
import RankPrepare from 'offline/filter/package/games/game/prepare/rank'
import RatingsPrepare from 'offline/filter/package/games/game/prepare/ratings'
import RenamesPrepare from 'offline/filter/package/games/game/prepare/renames'
import StatusPrepare from 'offline/filter/package/games/game/prepare/status'
import TagsPrepare from 'offline/filter/package/games/game/prepare/tags'

import AboutPackage from 'offline/filter/package/games/game/package/about'
import ContextPackage from 'offline/filter/package/games/game/package/context'
import GroupPackage from 'offline/filter/package/games/game/package/group'
import NestedPackage from 'offline/filter/package/games/game/package/nested'
import RankPackage from 'offline/filter/package/games/game/package/rank'
import TagsPackage from 'offline/filter/package/games/game/package/tags'
import UserPackage from 'offline/filter/package/games/game/package/user'
import UsersPackage from 'offline/filter/package/games/game/package/users'
import VersionsPackage from 'offline/filter/package/games/game/package/versions'

function sortUnits(units) {
	return units.slice().sort(function(a, b) {
		return (a.priority || 0) - (b.priority || 0)
	})
}

function runPrepare(units, local, global, config, filter) {
	var value = Object.assign({}, local)
	var sorted = sortUnits(units)

	for (var i = 0; i < sorted.length; i++) {
		var unit = sorted[i]
		if (unit.require && !unit.require(config, filter, null, global)) continue
		var result = unit.run(value, global, config, filter)
		if (result !== undefined) value = result
	}

	return value
}

function runPackage(units, prepared, global, config, filter) {
	var value = {}
	var sorted = sortUnits(units)

	for (var i = 0; i < sorted.length; i++) {
		var unit = sorted[i]
		if (unit.require && !unit.require(config, filter, null, global)) continue
		var result = unit.run(value, prepared, global, config, filter)
		if (result !== undefined) value = result
	}

	return value
}

export default {
	data_units: [
		ContextData,
		CommentsData,
		ExpansionsData,
		ListingData,
		NestedData,
		PlaysData,
		RankData,
		RatingsData,
		RenamesData,
		TagsData,
		VersionsData
	],

	prepare_units: [
		StatusPrepare,
		ContextPlaysPrepare,
		ExpansionsPrepare,
		OwnersPrepare,
		PlaysPrepare,
		RankPrepare,
		RatingsPrepare,
		RenamesPrepare,
		TagsPrepare
	],

	package_units: [
		AboutPackage,
		ContextPackage,
		GroupPackage,
		NestedPackage,
		RankPackage,
		TagsPackage,
		UserPackage,
		UsersPackage,
		VersionsPackage
	],

	run: function(resultId, local, global, config, filter) {
		var prepared = runPrepare(this.prepare_units, local, global, config, filter)
		var pkg = runPackage(this.package_units, prepared, global, config, filter)
		pkg.id = resultId
		return pkg
	}
}
